import React, { useEffect, useState } from "react";
import {
  Stack,
  Slider,
  Box,
  Autocomplete,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography, 
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Radio,
  ClickAwayListener,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { environmentDetails } from "../../../src/environment/environment";

import {
  getQuestionsData,
  postQuestionsData,
} from "../../Redux/Questions/action";
import { useDispatch, useSelector } from "react-redux";
import ApiAlert from "../AlertBox/ApiAlert";
import { getProcessName } from "../../Redux/IFlowData/action";
import ReuseableLabel from "../ReusableComponents/ReuseableLabel.jsx";
import {
  extractUnCommonWords,
  findSameQuestion2,
  findSimilarQuestions,
  getMasterTooltipMessage,
  isContainsDoubleDollar,
  isNoticePeriodQuestion,
  isExperienceQuestion,
  isAudioQuestion,
  isVideoQuestion,
  isUploadDocumentQuestion,
} from "../../utils/helperFunctions.js";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "../../constants/masterQuestion.js";
import DeleteAlert from "../AlertBox/DeleteAlert.jsx";
import { useThrottle } from "../../hooks/useThrottle";
import {
  getAllDocumentCategoriesActionFn,
  getDocumentSubCategoriesActionFn,
} from "../../Redux/documentCategory/action.js";
import InfoBox from "../Common/InfoBox.jsx";

// Import shared sections
import BasicSection from "./BasicSection";
import OtherSection from "./OtherSection";

const PrettoSlider = styled(Slider)({
  color: "#52af77",
  height: 4,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "blue",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 25,
    height: 25,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "blue",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

export const initailState = {
  Question: "",
  "Description": "",
  Weight: "",
  Ack: "",
  "job Description": "",
  "Process Variable": "",
  defaultValue: "",
  "Bot Interpreted": "",
  "Bot Name": "",
  Path: "",
  Adaptive: "",
  yPath: "",
  nPath: "",
  "Next Question Prefix": "",
  "Help Text": "",
  "Template Name": "",
  template_variable: "",
  expectDocument: "no",
  questionType: "",
  rangeStart: "",
  rangeEnd: "",
  mandatoryQuestion: "no",
  documentType: "",
  questionExpiry: "",
  "Attach Job Description": "n",
  "Scoring Engine Field Name": "",
  documentCategory: "",
};
const Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [alert, setAlert] = useState(false);
  const [alertContent, setalertcontent] = useState("");
  const [alertStatus, setAlertStatus] = useState(Boolean);
  const [selectedSection, setSelectedSection] = useState(1);
  const [isContainsDDollar, setIsContainsDDollar] = useState(false);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [masterQuestions, setMasterQuestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [similarQuestinToSave, setSimilarQuestionToSave] = useState(null);
  const [isSameQuestionExist, setIsSameQuestionExist] = useState(false);
  const [documentCategories, setDocumentCategories] = useState([]);
  const [documentSubCategories, setDocumentSubCategories] = useState([]);
  const throlltedFunction = useThrottle();

  //const [processVariables, setProcessVariables] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    reset,
    setValue,
    setFocus,
  } = useForm({
    mode: "all",
    defaultValues: initailState,
    resolver: yupResolver(schema),
  });
  // DOCUMENT CATEGORY WORK IN PROGESS
  const expectDocumentWatch = watch("expectDocument");
  const documentCategoryWatch = watch("documentCategory");
  const botInterpretedWatch = watch("Bot Interpreted");
  const botNameWatch = watch("Bot Name");
  const processVariableWatch = watch("Process Variable");

  const processNameData = useSelector(
    (state) => state.iflowDataReducer.processName,
  );
  const apiUrl = environmentDetails.apiUrl;

  const questionTitle = watch("Question");
  const scoringEngine = watch("Scoring Engine");

  useEffect(() => {
    if (scoringEngine === true) {
      getScoringEngineFieldName();
    } else {
      setValue("Scoring Engine Field Name", "");
    }
  }, [scoringEngine]);

  const getScoringEngineFieldName = () => {
    axios
      .post(`${apiUrl}scoringEngineFieldName/generate`, {
        question: questionTitle,
      })
      .then((res) => {
        setValue("Scoring Engine Field Name", res.data.data);
        setFocus("Scoring Engine Field Name");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // console.log("sscccccheema  ",schema);
  const createMasterQuestionDispatchFn = (data) => {
    console.log(data);

    dispatch(postQuestionsData(data))
      .then((res) => {
        if (res.type === "POST_QUESTIONS_SUCCESS") {
          setAlert(true);
          setAlertStatus(res.payload.status);
          setalertcontent(res.payload.message);
          console.log("postData", res);
          // dispatch(getQuestionsData());
          // navigate("/questions",{ state : {alertContent : res.payload.message, alertStatus: res.payload.status} });
          navigate("/questions");
          let questionToast = JSON.stringify({
            alertContent: res.payload.message,
            alertStatus: res.payload.status,
          });
          localStorage.setItem("questionToast", questionToast);
        } else {
          console.log("post new question erro");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSubmit = (data) => {
    let title = data.Question;
    let unCommonWords = extractUnCommonWords(title);
    data.keywords = unCommonWords;
    let questionKeyword = data.keywords;
    console.log("questionKeyword", questionKeyword);
    const isUploadDoc = questionKeyword.some(isUploadDocumentQuestion);

    if (isUploadDoc) {
      // explicitly keep defaults
      data["Bot Interpreted"] = "n";
      data["Bot Name"] = "";
    } else {
      if (data["Bot Interpreted"] !== "y") {
        const BOT_RULES = [
          { check: isNoticePeriodQuestion, flag: "y", name: "noticePeriod" },
          {
            check: isExperienceQuestion,
            flag: "c",
            name: "checkNumeric#years",
          },
          { check: isAudioQuestion, flag: "v", name: "voiceScore" },
          { check: isVideoQuestion, flag: "v", name: "videoScore" },
        ];

        for (const rule of BOT_RULES) {
          if (questionKeyword.some(rule.check)) {
            data["Bot Interpreted"] = rule.flag;
            data["Bot Name"] = rule.name;
            break; // 🚨 IMPORTANT: stop after first match
          }
        }
      }
      // ✅ PRIORITY-BASED BOT RULES
    }
    // ✅ Special case
    if (data["Bot Name"] === "yesOrNo") {
      data["Bot Interpreted"] = "y";
    }

    // other fixed fields
    data["Path"] = "y";
    data["yPath"] = "";
    data["nPath"] = "";
    data["Adaptive"] = "y";
    data["defaultValue"] = "";

    console.log("final data", data);
    // let templateDetails = template;
    // data["Template Name"] = templateDetails[0]["templateName"];
    if (filteredQuestions.length > 0) {
      setOpen(true);
      setSimilarQuestionToSave(data);
      return;
    }
    createMasterQuestionDispatchFn(data);
  };

  const handleSimilarQuestionSubmit = () => {
    createMasterQuestionDispatchFn(similarQuestinToSave);
    handleClose();
    //console.log("handle similar question submit ",similarQuestinToSave);
  };
  const [botInterpreted, setBotInterpreted] = useState();
  const [botNameDisabled, setBotNameDisabled] = useState(false);

  const handleBotInterpreted = (event) => {
    let curval = event.target.value;
    // console.log(curval)
    setBotInterpreted(curval);
    setBotNameDisabled(false);
    if (curval == "n") {
      setBotNameDisabled(true);
    }
  };

  useEffect(() => {
    dispatch(getProcessName());
    dispatch(getQuestionsData(1, 5000)).then((res) => {
      if (res.type === "GET_QUESTIONS_SUCCESS") {
        setMasterQuestions(res.payload);
      } else {
        console.log("fetching master question error", res);
      }
    });
  }, []);
  useEffect(() => {
    if (expectDocumentWatch === "yes" && !documentCategories.length) {
      dispatch(getAllDocumentCategoriesActionFn()).then((res) => {
        if (res.type === "GET_DOCUMENT_CATEGORIES_SUCCESS") {
          setDocumentCategories(res.payload);
        } else {
          setDocumentCategories([]);
        }
      });
    }
    if (expectDocumentWatch === "no") {
      setValue("documentType", "");
      setValue("documentCategory", "");
    }
    if (botInterpretedWatch === "n") {
      setValue("Bot Name", "");
    }
  }, [expectDocumentWatch, botInterpretedWatch]);

  var processVariables = [];
  processNameData.map((val) => {
    if (val.processkey == "Initiation_preScreeningProcess") {
      processVariables = val.processDef.variables;
    }
  });
  const AlerthandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert(false);
  };
  const onQuestionTitleKeyUp = (e) => {
    let value = e.target.value;
    //console.log("value", e);
    if (e.keyCode != 27) setMenuOpen(true);
    else setMenuOpen(false);
    let res = isContainsDoubleDollar(value);
    if (res) {
      setIsContainsDDollar(true);
    } else {
      setIsContainsDDollar(false);
    }
    let throttleFunc = throlltedFunction(
      (value) => handleThrottleFunction(value),
      800,
    );
    throttleFunc(value);
  };
  const handleTab = (e) => {
    if (e.keyCode != 9) setMenuOpen(true);
    else setMenuOpen(false);
  };
  let keyWordsQues = masterQuestions?.filter((ques) => ques.keywords);
  const handleThrottleFunction = (input) => {
    let similarQues = findSimilarQuestions(input, keyWordsQues);
    if (input && similarQues.length > 0) {
      let sameQuestion = findSameQuestion2(input, similarQues);
      if (sameQuestion.length > 0) {
        setIsSameQuestionExist(true);
      } else {
        setIsSameQuestionExist(false);
      }
      setFilteredQuestions(similarQues);
    } else {
      setFilteredQuestions([]);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseMenu = () => {
    setMenuOpen(false);
  };
  
  const handleMenuItemClick = (question) => {
    setMenuOpen(false);
    setValue("Question", question.Question);//add this 
  };
  useEffect(() => {
    if (documentCategoryWatch === "KYC" && !documentSubCategories.length) {
      dispatch(getDocumentSubCategoriesActionFn()).then((res) => {
        if (res.type === "GET_DOCUMENT_SUB_CATEGORIES_SUCCESS") {
          setDocumentSubCategories(res.payload);
        }
      });
    } else {
      setDocumentSubCategories([]);
      setValue("documentType", "");
    }
  }, [documentCategoryWatch]);
  //Get current value the "Question" input field
  const watchedQuestion = watch("Question");
  // Check if the question already exists in masterQuestions array
  const isQuestionExistsInDb = masterQuestions?.some((q) => {
   return (
     q.Question?.trim().toLowerCase() ===
     watchedQuestion?.trim().toLowerCase()
   );
   });

  return (
    <Box
      sx={{
        width: "80%",
        margin: "auto",
        boxSizing: "border-box",
        paddingLeft: {
          xs: "0",
          sm: "50px",
          md: "50px",
          lg: "50px",
          xl: "50px",
        },
        paddingRight: {
          xs: "0",
          sm: "50px",
          md: "50px",
          lg: "50px",
          xl: "50px",
        },
      }}
    >
      {alert && (
        <ApiAlert
          open={alert}
          snackbaronClose={AlerthandleClose}
          alertonClose={AlerthandleClose}
          alertType={alertStatus ? "success" : "error"}
          Content={alertContent}
        />
      )}
      <Typography
        variant="h4"
        component="h2"
        style={{ marginBottom: "15px", marginTop: 0 }}
      >
        Add Master Question
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ width: "100%", position: "relative" }}>
    
    <TextField
      fullWidth
      variant="outlined"
      autoComplete="off"
      type="text"
      label={<ReuseableLabel label={"Question"} />}
      name="Question"
      maxRows={2}
      placeholder="Add Your Question here"
      InputProps={{ sx: { borderRadius: "6px" } }}
      {...register("Question", { required: "Question is Required" })}
      onKeyUp={onQuestionTitleKeyUp}
      onKeyDown={handleTab}
      error={Boolean(errors.Question)}
      helperText={errors.Question?.message}
    />
    {isQuestionExistsInDb && (
    <Typography color="error" fontSize="12px" mt={1}>
      This question already exists 
    </Typography>// If isQuestionExistsInDb is true, show this message
    )}

    {/* ✅ DROPDOWN */}
    {filteredQuestions.length > 0 && menuOpen && (
      <ClickAwayListener onClickAway={handleCloseMenu}>
        <Box
          sx={{
            maxHeight: 200,
            overflowY: "auto",
            overflowX: "hidden",
            boxShadow: 3,
            borderBottomRightRadius: "7px",
            borderBottomLeftRadius: "7px",
            backgroundColor: "#fff",
            position: "absolute",
            width: "100%",
            zIndex: 10,
          }}
        >
          {filteredQuestions.map((item,index) => (
            <MenuItem
              key={`${item.Question}-${item.id}-${index}`}  // ✅ stable key
              onClick={() => {
                handleMenuItemClick(item);
                setMenuOpen(false);
              }}
            >
              {item.Question}
            </MenuItem>
          ))}
        </Box>
      </ClickAwayListener>
    )}

  </Box>
        <></>
        <Box
          sx={{
            width: "100%",
            mt: "20px",
          }}
        >
          <FormControl component="fieldset">
            <FormLabel component="legend">Attach Job Description</FormLabel>
            <Controller
              rules={{ required: true }}
              control={control}
              name="Attach Job Description"
              render={({ field }) => (
                <RadioGroup {...field} row>
                  <FormControlLabel value="y" control={<Radio />} label="Yes" />
                  <FormControlLabel value="n" control={<Radio />} label="No" />
                </RadioGroup>
              )}
            />
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "3px",
            mt: 3,
            justifyContent: "flex-start",
            flexWrap: "wrap",
          }}
        >
          {[
            { id: 1, label: "Basic Section" },
            { id: 2, label: "Other Section" },
          ].map((tab) => (
            <Box
              key={tab.id}
              onClick={() => setSelectedSection(tab.id)}
              sx={{
                cursor: "pointer",
                px: 2,
                py: 1,
                borderRadius: 2,
                fontWeight: 500,
                fontSize: "0.95rem",
                transition: "all 0.3s ease",
                backgroundColor:
                  selectedSection === tab.id ? "#092244" : "#f0f0f0",
                color: selectedSection === tab.id ? "white" : "#333",
                "&:hover": {
                  backgroundColor:
                    selectedSection === tab.id ? "#092244" : "#e0e0e0",
                  color: selectedSection === tab.id ? "white" : "#000",
                },
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            height: "auto",
          }}
        >
          <Stack direction="row" gap={5} sx={{ width: "100%" }}>
            {selectedSection === 1 ? (
              /*
              <>
                <Stack
                  direction={"column"}
                  gap={2}
                  width={{
                    md: "80%",
                    lg: "80%",
                    xl: "80%",
                    sm: "100%",
                    xs: "100%",
                  }}
                  margin={"0 auto"}
                  mt={"20px"}
                >
                  <Box
                    width={"100%"}
                    height={"auto"}
                    sx={{ border: "0px solid green" }}
                  >
                    <Box
                      sx={{
                        width: "auto",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "7px",
                      }}
                    >
                      <Stack
                        direction="column"
                        sx={{ border: "0px solid blue" }}
                      >
                        <FormControl component="fieldset">
                          <Controller
                            name="Bot Interpreted"
                            control={control}
                            render={({ field }) => (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    {...field}
                                    checked={
                                      field.value === "y" &&
                                      watch("Bot Name") === "yesOrNo"
                                    }
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setValue(
                                        "Bot Interpreted",
                                        checked ? "y" : "n",
                                        {
                                          shouldDirty: true,
                                          shouldTouch: true,
                                        },
                                      );
                                      setValue(
                                        "Bot Name",
                                        checked ? "yesOrNo" : "",
                                        {
                                          shouldDirty: true,
                                          shouldTouch: true,
                                        },
                                      );
                                    }}
                                  />
                                }
                                label="Answer in Yes or No only"
                              />
                            )}
                          />
                        </FormControl>
                      </Stack>
                    </Box>
                  </Box>
                  <Box sx={{ border: "0px solid red" }}>
                    <Stack>
                      <FormControl
                        variant="outlined"
                        size="small"
                        error={Boolean(errors.questionType)}
                      >
                        <InputLabel id="demo-simple-select-required-label">
                          <ReuseableLabel label={"Question Type"} />
                        </InputLabel>
                        <Controller
                          name="questionType"
                          control={control}
                          defaultValue=""
                          rules={{ required: "Please select an option" }}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                labelId="demo-simple-select-required-label"
                                id="demo-simple-select-required"
                                label="Question Type*"
                                defaultValue=""
                                style={{ height: "43px" }}
                                error={Boolean(errors.questionType)}
                              >
                                <MenuItem value={""}>
                                  Please select an option
                                </MenuItem>
                                <MenuItem value={"Default Question"}>
                                  Default Question
                                </MenuItem>
                                <MenuItem value={"Generic Question"}>
                                  Generic Question
                                </MenuItem>
                                <MenuItem value={"Profile Gap Question"}>
                                  Profile Gap Question
                                </MenuItem>
                                <MenuItem value={"Assessment Question"}>
                                  Assessment Question
                                </MenuItem>
                                <MenuItem value={"Job Specific Question"}>
                                  Job Specific Question
                                </MenuItem>
                                <MenuItem value={"POFU Question"}>
                                  POFU Question
                                </MenuItem>
                                <MenuItem value={"Offer Question"}>
                                  Offer Question
                                </MenuItem>
                                <MenuItem value={"Onboarding Question"}>
                                  Onboarding Question
                                </MenuItem>
                                <MenuItem value={"BlueCollar Question"}>
                                  BlueCollar Question
                                </MenuItem>
                                <MenuItem value={"Document Collection Question"}>
                                  Document Collection Question
                                </MenuItem>
                              </Select>
                              {errors.questionType && (
                                <FormHelperText error>
                                  {errors.questionType.message}
                                </FormHelperText>
                              )}
                            </>
                          )}
                        />
                      </FormControl>

                      <FormControl
                        variant="outlined"
                        style={{ marginTop: 11, minWidth: 150 }}
                        size="small"
                        error={Boolean(errors.mandatoryQuestion)}
                      >
                        <InputLabel id="demo-simple-select-required-label">
                          Mandatory Question
                        </InputLabel>
                        <Controller
                          name="mandatoryQuestion"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                labelId="mandatoryQuestion"
                                id="mandatoryQuestionId"
                                label="mandatoryQuestion"
                                defaultValue=""
                                style={{ height: "43px" }}
                                error={Boolean(errors.mandatoryQuestion)}
                              >
                                <MenuItem value={""}>
                                  Please select an option
                                </MenuItem>
                                <MenuItem value={"yes"}>Yes</MenuItem>
                                <MenuItem value={"no"}>No</MenuItem>
                              </Select>
                              {errors.mandatoryQuestion && (
                                <FormHelperText error>
                                  {errors.mandatoryQuestion.message}
                                </FormHelperText>
                              )}
                            </>
                          )}
                        />
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{ marginTop: 11, minWidth: 150 }}
                        size="small"
                        error={Boolean(errors.questionExpiry)}
                      >
                        <InputLabel id="demo-simple-select-required-label">
                          <ReuseableLabel label={"Question Expiry"} />
                        </InputLabel>
                        <Controller
                          name="questionExpiry"
                          control={control}
                          defaultValue=""
                          rules={{ required: "Please select an option" }}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                labelId="questionExpiry"
                                id="questionExpiryId"
                                label="Question Expiry*"
                                defaultValue=""
                                style={{ height: "43px" }}
                                error={Boolean(errors.questionExpiry)}
                              >
                                <MenuItem value={""}>
                                  Please select an option
                                </MenuItem>
                                <MenuItem value={"never"}>Never</MenuItem>
                                <MenuItem value={"15"}>15 days</MenuItem>
                                <MenuItem value={"30"}>30 days</MenuItem>
                                <MenuItem value={"90"}>90 days</MenuItem>
                                <MenuItem value={"180"}>180 days</MenuItem>
                                <MenuItem value={"365"}>365 days</MenuItem>
                              </Select>
                              {errors.questionExpiry && (
                                <FormHelperText error>
                                  {errors.questionExpiry.message}
                                </FormHelperText>
                              )}
                            </>
                          )}
                        />
                      </FormControl>
                      <Controller
                        name="Weight"
                        control={control}
                        rules={{ required: "Weight is Required" }}
                        render={({ field }) => (
                          <Box
                            sx={{
                              marginTop: 1,
                              minWidth: 150,
                              border: "1px solid #908E8E",
                              borderRadius: "7px",
                              height: "43px",
                            }}
                          >
                            <Stack direction="row" spacing={2} padding={1.2}>
                              <Typography
                                sx={{
                                  paddingTop: "1px",
                                  paddingLeft: "5px",
                                  opacity: 0.7,
                                  display: "flex",
                                  gap: "2px",
                                }}
                              >
                                Weightage{" "}
                                <span style={{ color: "red" }}> *</span>
                              </Typography>

                              <PrettoSlider
                                {...field}
                                value={field.value ?? 0.1}
                                onChange={(_, value) => field.onChange(value)}
                                valueLabelDisplay="auto"
                                min={0.1}
                                step={0.1}
                                max={1}
                                sx={{ width: "80%", marginLeft: "8%" }}
                              />
                            </Stack>

                            {errors.Weight && (
                              <Typography color="error" fontSize={12} pl={2}>
                                {errors.Weight.message}
                              </Typography>
                            )}
                          </Box>
                        )}
                      />
                    </Stack>
                  </Box>
                </Stack>
              </>
              */
              // Replaced  with sheared component
              <BasicSection
                control={control}
                errors={errors}
                watch={watch}
                setValue={setValue}
                register={register}
                isEditMode={false}
                defaultValues={{}}
                PrettoSlider={PrettoSlider}
              />
            ) : (     
              /*
              <>
                <Stack
                  direction={"column"}
                  gap={2}
                  width={{
                    md: "80%",
                    lg: "80%",
                    xl: "80%",
                    sm: "100%",
                    xs: "100%",
                  }}
                  margin={"0 auto"}
                  mt={"20px"}
                >
                  <Box>
                    <Stack direction="column" spacing={1}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Acknowledgement"
                        type="text"
                        placeholder="Acknowledgement"
                        size="small"
                        {...register("Ack")}
                        error={Boolean(errors.Ack)}
                        helperText={errors.Ack?.message}
                      />

                      <Controller
                        name="Process Variable"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            {...field}
                            disablePortal
                            fullWidth
                            size="small"
                            filterSelectedOptions
                            options={processVariables}
                            getOptionLabel={(option) => option}
                            value={field.value || null}
                            onChange={(_, value) => field.onChange(value ?? "")}
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Process Variable"
                                error={!!errors["Process Variable"]}
                                helperText={errors["Process Variable"]?.message}
                              />
                            )}
                          />
                        )}
                      />

                      <Box
                        sx={{
                          border: "0px solid green",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              {...register("Scoring Engine")}
                            />
                          }
                          label="Scoring Engine"
                        />
                      </Box>

                      <TextField
                        fullWidth
                        variant="outlined"
                        type="text"
                        placeholder="Help Text"
                        label="Help Text"
                        inputProps={{
                          style: {},
                        }}
                        size="small"
                        {...register("Help Text")}
                        error={Boolean(errors?.["Help Text"])}
                        helperText={errors?.["Help Text"]?.message}
                      />

                      <Stack direction="column" spacing={1}>
                        <FormControl
                          variant="outlined"
                          style={{ marginTop: 1, minWidth: 150 }}
                          size="small"
                          error={Boolean(errors.expectDocument)}
                        >
                          <InputLabel id="demo-simple-select-required-label">
                            Expect Document
                          </InputLabel>
                          <Controller
                            name="expectDocument"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <>
                                <Select
                                  {...field}
                                  labelId="demo-simple-select-required-label"
                                  id="demo-simple-select-required"
                                  label="Expect Document"
                                  defaultValue=""
                                >
                                  <MenuItem value={""}>
                                    Please select an option
                                  </MenuItem>

                                  <MenuItem value={"yes"}>Yes</MenuItem>
                                  <MenuItem value={"no"}>No</MenuItem>
                                </Select>
                              </>
                            )}
                          />
                        </FormControl>
                        <FormControl
                          variant="outlined"
                          style={{ marginTop: 11, minWidth: 150 }}
                          size="small"
                          error={Boolean(errors.documentCategory)}
                        >
                          <InputLabel id="documentType">
                            Document Categories
                          </InputLabel>
                          <Controller
                            name="documentCategory"
                            control={control}
                            render={({ field }) => (
                              <>
                                <Select
                                  {...field}
                                  labelId="documentCategory"
                                  id="documentCategoryId"
                                  label="Document Categories"
                                  defaultValue=""
                                  style={{ height: "43px" }}
                                  error={Boolean(errors.documentCategory)}
                                  disabled={
                                    expectDocumentWatch !== "yes" ? true : false
                                  }
                                >
                                  {documentCategories.map((cate, idx) => {
                                    return (
                                      <MenuItem key={idx} value={cate.code}>
                                        {cate.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                                {errors.documentCategory && (
                                  <FormHelperText error>
                                    {errors.documentCategory.message}
                                  </FormHelperText>
                                )}
                              </>
                            )}
                          />
                        </FormControl>
                        <>
                          {documentSubCategories.length > 0 && (
                            <FormControl
                              variant="outlined"
                              style={{ marginTop: 11, minWidth: 150 }}
                              size="small"
                              error={Boolean(errors.documentType)}
                            >
                              <InputLabel id="documentType">
                                Document Type
                              </InputLabel>
                              <Controller
                                name="documentType"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                  <>
                                    <Select
                                      {...field}
                                      labelId="documentType"
                                      id="documentType"
                                      label="Document Type"
                                      defaultValue=""
                                      style={{ height: "43px" }}
                                      error={Boolean(errors.documentType)}
                                      disabled={
                                        expectDocumentWatch !== "yes"
                                          ? true
                                          : false
                                      }
                                    >
                                      {documentSubCategories.map(
                                        (scate, idx) => {
                                          return (
                                            <MenuItem
                                              key={idx}
                                              value={scate.name}
                                            >
                                              {scate.name}
                                            </MenuItem>
                                          );
                                        },
                                      )}
                                    </Select>
                                    {errors.documentType && (
                                      <FormHelperText error>
                                        {errors.documentType.message}
                                      </FormHelperText>
                                    )}
                                  </>
                                )}
                              />
                            </FormControl>
                          )}
                        </>
                      </Stack>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <InfoBox
                          message={getMasterTooltipMessage("range", "range")}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "25px",
                          }}
                        >
                          <TextField
                            variant="outlined"
                            type="number"
                            label="Range Start"
                            name="rangeStart"
                            size="small"
                            placeholder="Range Start"
                            InputProps={{
                              sx: { borderRadius: "6px", width: "100%" },
                            }}
                            {...register("rangeStart")}
                            error={Boolean(errors.rangeStart)}
                            helperText={errors.rangeStart?.message}
                          />

                          <TextField
                            variant="outlined"
                            type="number"
                            label="Range End"
                            name="rangeEnd"
                            placeholder="Range End"
                            size="small"
                            InputProps={{
                              sx: { borderRadius: "6px", width: "100%" },
                            }}
                            {...register("rangeEnd")}
                            error={Boolean(errors.rangeEnd)}
                            helperText={errors.rangeEnd?.message}
                          />
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                </Stack>
              </>
              */
              // REPLACED WITH SHARED COMPONENT
              <OtherSection
                control={control}
                errors={errors}
                watch={watch}
                setValue={setValue}
                register={register}
                processVariableWatch={processVariableWatch}
                processVariables={processVariables}
                expectDocumentWatch={expectDocumentWatch}
                documentCategories={documentCategories}
                documentSubCategories={documentSubCategories}
                isEditMode={false}
                defaultValues={{}}
              />
            )}
          </Stack>
        </Box>

        <Stack
          direction={"row"}
          gap={6}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginY: "20px",
          }}
        >
          <Button
            sx={{
              width: "140px",
              height: "41px",
              boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "500",
              backgroundColor: "primary.main",
              color: "secondary.main",
              "&.Mui-disabled": {
              backgroundColor: "#c4c4c4", // gray background
              color: "#6f6f6f",          // gray text
              cursor: "not-allowed",
               boxShadow: "none",}
            }}
            type="submit"
            disabled={isQuestionExistsInDb}
          >
            Save
          </Button>

          <Button
            sx={{
              width: "140px",
              height: "41px",
              boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "500",
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
            onClick={() => navigate("/questions")}
          >
            Cancel
          </Button>
        </Stack>
      </form>
      <DeleteAlert
        /*open={open}
        onClose={handleClose}
        handleClose={handleClose}
        handleDelete={handleSimilarQuestionSubmit}
        header={`${isSameQuestionExist ? "Same" : "Similar"} Question`}
        message={`${
          isSameQuestionExist ? "Same" : "Similar"
        } question is available do you still want to create a new question?`}
        rightButton={"Create"}*/
        open={open}
        onClose={handleClose}
        handleClose={handleClose}
        handleDelete={handleSimilarQuestionSubmit}
        header={"Are you sure?"}  // ✅ NEW HEADER
        message={"Are you sure you want to create this question?"}  // ✅ NEW MESSAGE
        rightButton={"Yes, Create"}  // ✅ NEW BUTTON TEXT
      />
    </Box>
  );
};

export default Form;